import { useAppSelector } from "../hooks";

export const useCanStartQuiz = () => {
  const { data, status } = useAppSelector(
    ({ quizTries }) => quizTries.canStartQuiz
  );

  return {
    data,
    status,
  };
};

export const useGetQuizActions = () => {
  const { data, status } = useAppSelector(
    ({ quizTries }) => quizTries.quizActions
  );

  return {
    data,
    status,
  };
};

export const useGetQuizInstructions = () => {
  const { data, status } = useAppSelector(
    ({ quizTries }) => quizTries.quizInstructions
  );

  return {
    data,
    status,
  };
};

export const useStartQuiz = () => {
  const { data, status } = useAppSelector(
    ({ quizTries }) => quizTries.startQuiz
  );

  return {
    data,
    status,
  };
};

export const useSubmitAnswer = () => {
  const { status } = useAppSelector(({ quizTries }) => quizTries.submitAnswers);

  return {
    status,
  };
};

export const useCompleteQuiz = () => {
  const { data, status } = useAppSelector(
    ({ quizTries }) => quizTries.completeQuiz
  );

  return {
    data,
    status,
  };
};

export const useCancelQuiz = () => {
  const { status } = useAppSelector(({ quizTries }) => quizTries.cancelQuiz);

  return {
    status,
  };
};

export const useGetQuestionsAndAnswers = () => {
  const { data, status } = useAppSelector(
    ({ quizTries }) => quizTries.questionsAndAnswers
  );

  return {
    data,
    status,
  };
};
